import { Location } from '../../../compoundManagement/compoundManagement.types';
import { mapToPartialAddress } from '../addressMappers';
import { ApiLocation } from '../../types/compoundManagement/location.types';

export const mapToLocation = (apiLocation: ApiLocation): Location => ({
    identifier: apiLocation.identifier,
    address: apiLocation.address && mapToPartialAddress(apiLocation.address),
});
